// extracted by mini-css-extract-plugin
module.exports = {"container":"src-screens-BrandsPage-components-PageHeader-PageHeader-module__container--FV6Z-"};